export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://www.lingify.co"
).replace(/\/$/, "");

export const SITE_NAME = "Lingify";

// Admin panelindeki "Siteyi Güncelle" butonunun çağırdığı Cloudflare Worker adresi.
export const PUBLISH_WORKER_URL = "https://lingify-publish.talhaegitim.workers.dev";

export const DEFAULT_DESCRIPTION =
  "Afazi ve nörojenik iletişim bozuklukları için teknoloji destekli terapi ve farkındalık platformu.";
